import { useMemo } from "react";
import { FormTemplateItem } from "types/formTemplate";
import { IconName } from "../components/AnimalCard";

type DynamicItem = {
  type: IconName;
  uid: number;
  pet_id?: string | null;
};

export const useGroupedItems = (items: DynamicItem[]) => {
  return useMemo(() => {
    const grouped: { [key in IconName]?: DynamicItem[] } = {};
    items.forEach((item) => {
      if (!grouped[item.type]) grouped[item.type] = [];
      grouped[item.type]!.push(item);
    });
    return grouped;
  }, [items]);
}

export const useFormTemplate = (rawFormTemplate: any): FormTemplateItem[] => {
  return useMemo(() => {
    try {
      if (Array.isArray(rawFormTemplate)) return rawFormTemplate;
      if (typeof rawFormTemplate === "string" && rawFormTemplate.trim() !== "")
        return JSON.parse(rawFormTemplate);
    } catch (e) {
      // Failed to parse form template JSON
    }
    return [];
  }, [rawFormTemplate]);
}

// export const useAgentFormTemplatee = () => {
//   const [agentFormTemplate, setAgentFormTemplate] = useState<any>(null);
//   useEffect(() => {
//     fetch("/agent_form.json")
//       .then((res) => res.json())
//       .then(setAgentFormTemplate)
//       .catch((err) => console.error("Failed to load agent_form.json:", err));
//   }, []);
//   return agentFormTemplate;
// }